import * as React from 'react';
import { Select, SelectOption } from '@SBGSports/referee-react';

export interface CellDropdownSelectProps {
    testId: string;
    options: SelectOption[];
    onChange: (value: SelectOption) => void;
}

export const CellDropdownSelect: React.FC<CellDropdownSelectProps> = (props) => {
    const { testId, options, onChange } = props;

    return (
        <Select
            testId={`cell-dropdown-select-${testId}`}
            menuItems={options}
            placeholder={''}
            onSelectItem={(selectedItem) => {
                onChange(selectedItem?.[0]);
            }}
            size={'small'}
            isClearButtonVisible
        />
    );
};
